import axios from "axios";

export default {
  namespaced: true,
  state: {
    messages: [],
    error: '',
    messagesInThread: [],
    totalMessagesCount: 0,
  },
  getters:{
    messageList(state){
      return state.messages.map(message => ({
        ...message,
        isCollapsed: true,
      }))
    },
    threadMessageList(state){
      return state.messagesInThread.map(message => ({
        ...message,
        isCollapsed: true,
      }))
    },
  },
  mutations:{
    setMessages(state, messages) {
      state.messages = messages;
    },
    setMessagesInThread(state, messages) {
      state.messagesInThread = messages;
    },
    setTotalMessagesCount(state, total){
      state.totalMessagesCount = total;
    },
    setError(state, error) {
      state.error = `Error connecting to Nylas MS: ${error}`;
    },
  },
  actions: {
    async findMessages({commit}, payload) {
      try {
        const { contactId, limit, page } = payload;
        const response = await axios.get(
          `${process.env.VUE_APP_NYLAS_API_BASE_URL}/messages/find-by-contact-id?app=crm&contact_id=${contactId}&page=${page}&limit=${limit}`)
        commit("setMessages", response.data.messages);
        commit("setTotalMessagesCount", response.data.total);
      } catch(error) {
        commit('setError', error.message);
      }
    },
    async getThreadMessages({commit}, payload) {
      try {
        const { threadId, emailAccountId } = payload;
        const response = await axios.get(`${process.env.VUE_APP_NYLAS_API_BASE_URL}/threads/${threadId}/messages?app=crm&email_account_id=${emailAccountId}`)
        commit("setMessagesInThread", response.data.messages);
      } catch(error) {
        commit('setError', error.message);
      }
    },
  },
};
